import { render } from "./ProductCardGrid.vue?vue&type=template&id=60a2a2a9&scoped=true"
import script from "./ProductCardGrid.vue?vue&type=script&lang=js"
export * from "./ProductCardGrid.vue?vue&type=script&lang=js"

import "./ProductCardGrid.vue?vue&type=style&index=0&id=60a2a2a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2a2a9"]])

export default __exports__